module.exports = __webpack_public_path__ + "fonts/Roboto-400-latin7.4673b45.woff2";